module.exports = __webpack_public_path__ + "media/images/scoreBet__detailScore__markWrong-0d804e66245421ee994270554dad8a51.png";